module.exports = __webpack_public_path__ + "img/privilege10.78b21289.png";